export const REFERRAL_STEP = 1;
export const AGE_VERIFICATION_STEP = 3;
export const USER_DETAILS_STEP = 2;
